export const getPagination = ({ pagination }) => pagination;

export const getContactsEmpty = () => {
  return {
    phones: [{ value: "" }],
    emails: [{ value: "" }],
    social_networks: [{ value: "" }]
  };
};
